/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { AuthzPolicyFragmentDoc } from './SettingsPageAuthzPolicyDetailView.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type AnyAuthzPolicyActionInput = {
  /** 何かフィールドを持つ必要があるのでつけている */
  _dummyField?: boolean | null | undefined;
};

export type AnyAuthzPolicyPrincipalInput = {
  /** 何かフィールドを持つ必要があるのでつけている */
  _dummyField?: boolean | null | undefined;
};

export type AnyAuthzPolicyResourceInput = {
  /** 何かフィールドを持つ必要があるのでつけている */
  _dummyField?: boolean | null | undefined;
};

export type AuthzPolicyActionInput = {
  /** oneof */
  anyAction?: AnyAuthzPolicyActionInput | null | undefined;
  readRoomAction?: ReadRoomAuthzPolicyActionInput | null | undefined;
};

export type AuthzPolicyEffect =
  | 'FORBID'
  | 'PERMIT';

export type AuthzPolicyPrincipalInput = {
  /** oneof */
  anyPrincipal?: AnyAuthzPolicyPrincipalInput | null | undefined;
  staffPrincipal?: StaffAuthzPolicyPrincipalInput | null | undefined;
  teamPrincipal?: TeamAuthzPolicyPrincipalInput | null | undefined;
};

export type AuthzPolicyResourceInput = {
  /** oneof */
  anyResource?: AnyAuthzPolicyResourceInput | null | undefined;
  roomResource?: RoomAuthzPolicyResourceInput | null | undefined;
};

export type ReadRoomAuthzPolicyActionInput = {
  isAssigned: boolean;
};

export type RoomAuthzPolicyResourceInput = {
  roomID: string | number;
};

export type StaffAuthzPolicyPrincipalInput = {
  staffGUID: string | number;
};

export type TeamAuthzPolicyPrincipalInput = {
  teamGUID: string | number;
};

export type UpdateAuthzPolicyInput = {
  action: AuthzPolicyActionInput;
  effect: AuthzPolicyEffect;
  guid: string | number;
  name: string;
  principal: AuthzPolicyPrincipalInput;
  resource: AuthzPolicyResourceInput;
};

export type SettingsPageAuthzPolicyEditViewQueryVariables = Exact<{
  guid: string | number;
}>;


export type SettingsPageAuthzPolicyEditViewQuery = { authzPolicy: { guid: string, name: string, effect: Types.AuthzPolicyEffect, principal:
      | { __typename: 'AnyAuthzPolicyPrincipal' }
      | { __typename: 'StaffAuthzPolicyPrincipal', staffGUID: string }
      | { __typename: 'TeamAuthzPolicyPrincipal', teamGUID: string }
    , action:
      | { __typename: 'AnyAuthzPolicyAction' }
      | { __typename: 'ReadRoomAuthzPolicyAction', isAssigned: boolean }
    , resource:
      | { __typename: 'AnyAuthzPolicyResource' }
      | { __typename: 'RoomAuthzPolicyResource', roomID: string }
     } };

export type UpdateAuthzPolicyMutationVariables = Exact<{
  input: Types.UpdateAuthzPolicyInput;
}>;


export type UpdateAuthzPolicyMutation = { updateAuthzPolicy: { __typename: 'UpdateAuthzPolicySuccessPayload' } };


export const SettingsPageAuthzPolicyEditViewDocument = gql`
    query SettingsPageAuthzPolicyEditView($guid: ID!) {
  authzPolicy(guid: $guid) {
    ...AuthzPolicy
  }
}
    ${AuthzPolicyFragmentDoc}`;

/**
 * __useSettingsPageAuthzPolicyEditViewQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageAuthzPolicyEditViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageAuthzPolicyEditViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageAuthzPolicyEditViewQuery({
 *   guid: // value for 'guid'
 * });
 */
export function useSettingsPageAuthzPolicyEditViewQuery(variables: SettingsPageAuthzPolicyEditViewQueryVariables | VueCompositionApi.Ref<SettingsPageAuthzPolicyEditViewQueryVariables> | ReactiveFunction<SettingsPageAuthzPolicyEditViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyEditViewQuery, SettingsPageAuthzPolicyEditViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyEditViewQuery, SettingsPageAuthzPolicyEditViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyEditViewQuery, SettingsPageAuthzPolicyEditViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageAuthzPolicyEditViewQuery, SettingsPageAuthzPolicyEditViewQueryVariables>(SettingsPageAuthzPolicyEditViewDocument, variables, options);
}
export function useSettingsPageAuthzPolicyEditViewLazyQuery(variables?: SettingsPageAuthzPolicyEditViewQueryVariables | VueCompositionApi.Ref<SettingsPageAuthzPolicyEditViewQueryVariables> | ReactiveFunction<SettingsPageAuthzPolicyEditViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyEditViewQuery, SettingsPageAuthzPolicyEditViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyEditViewQuery, SettingsPageAuthzPolicyEditViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageAuthzPolicyEditViewQuery, SettingsPageAuthzPolicyEditViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageAuthzPolicyEditViewQuery, SettingsPageAuthzPolicyEditViewQueryVariables>(SettingsPageAuthzPolicyEditViewDocument, variables, options);
}
export type SettingsPageAuthzPolicyEditViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageAuthzPolicyEditViewQuery, SettingsPageAuthzPolicyEditViewQueryVariables>;
export const UpdateAuthzPolicyDocument = gql`
    mutation UpdateAuthzPolicy($input: UpdateAuthzPolicyInput!) {
  updateAuthzPolicy(input: $input) {
    __typename
  }
}
    `;

/**
 * __useUpdateAuthzPolicyMutation__
 *
 * To run a mutation, you first call `useUpdateAuthzPolicyMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthzPolicyMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAuthzPolicyMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAuthzPolicyMutation(options: VueApolloComposable.UseMutationOptions<UpdateAuthzPolicyMutation, UpdateAuthzPolicyMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAuthzPolicyMutation, UpdateAuthzPolicyMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAuthzPolicyMutation, UpdateAuthzPolicyMutationVariables>(UpdateAuthzPolicyDocument, options);
}
export type UpdateAuthzPolicyMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAuthzPolicyMutation, UpdateAuthzPolicyMutationVariables>;